import { Modal, type ModalProps } from '@mntn-dev/ui-components'

type NotificationModalProps = ModalProps

const NotificationModal = ({ children, ...props }: NotificationModalProps) => (
  <Modal
    {...props}
    backgroundBlur="blur-md"
    align="start"
    justify="start"
    width="auto"
    className="left-16"
    suppressUserClose={true}
  >
    {children}
  </Modal>
)

export { NotificationModal, type NotificationModalProps }
